var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningFreePackage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 50,
    viewBox: "0 0 90 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.3885 15.8356L89.1804 16.2425L85.2323 0.822266L53.5166 13.2139L59.8126 13.7486L39.2495 34.5465H26.8774L0.104004 50.9115H36.4339L53.0512 35.0312H65.4096L84.3885 15.8356Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3269 31.8398C34.3269 31.8398 35.451 31.9017 35.5887 34.3074C35.5887 34.3074 32.9827 36.7392 29.462 37.3179C29.1976 37.3611 29.8313 35.4401 29.9267 35.1799C30.3801 33.9424 31.8079 33.145 34.3269 31.8398Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.985 29.0087H44.6141C44.6141 29.0087 37.334 20.6409 32.5593 19.7969C32.5593 19.7969 29.2358 24.2125 32.7364 32.4626C33.0179 33.1265 33.8055 33.4213 34.3928 33.0308C34.5637 32.92 34.6963 32.7554 34.7715 32.561L34.4899 25.5166C34.4899 25.5166 40.6998 31.1693 41.779 32.2601C42.8583 33.3509 48.3449 32.6861 46.985 29.0087Z",
    fill: "#7D97F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0552 46.5764C25.049 45.6702 26.633 44.653 28.9192 44.3613L29.6922 44.8535C29.6922 44.8535 29.1991 45.6103 28.2985 46.4084C27.4706 46.909 26.1926 47.5868 25.1328 47.7335C24.1019 47.8781 23.9499 47.2298 24.0552 46.5764Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9268 35.1816C30.539 35.3878 30.8083 36.2907 32.3627 35.6937C33.4974 35.2584 34.5719 34.6692 35.5586 33.9414C35.5712 34.058 35.5823 34.178 35.5894 34.3092C35.5894 34.3092 32.8414 37.0296 29.3211 37.6083C29.2605 37.6176 29.1987 37.6102 29.1417 37.5869C29.0848 37.5636 29.0347 37.5252 28.9964 37.4755C28.9581 37.4258 28.933 37.3665 28.9236 37.3036C28.9142 37.2407 28.9208 37.1763 28.9427 37.1168C29.1955 36.4332 29.5259 35.7836 29.9268 35.1816Z",
    fill: "#91B3FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3058 47.3528C23.5386 47.0784 23.7881 46.8199 24.0528 46.5788C23.9482 47.2321 24.1002 47.8801 25.1304 47.7372C26.1902 47.5905 27.4689 46.9127 28.2961 46.4121C27.2587 47.3332 25.6799 48.3108 23.6874 48.2533C23.2466 48.2405 23.0131 47.699 23.3058 47.3528Z",
    fill: "#91B3FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.899 30.7949L35.7914 30.9203C35.7914 30.9203 29.4483 36.3821 28.2976 44.7117C28.2976 44.7117 28.1066 45.3242 29.2531 45.4289C29.2531 45.4289 33.0882 42.8221 35.5887 38.2132C38.655 32.5621 44.7291 35.1061 44.7291 35.1061C47.6477 35.7764 49.9702 35.5269 51.6701 32.8045L46.899 30.7949Z",
    fill: "#7D97F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6366 21.4824C46.6366 21.4824 45.441 27.7193 39.5822 30.1865L37.4981 29.9296L37.0063 30.7456L41.895 30.9075C41.895 30.9075 46.0734 29.1836 48.2875 24.4915C48.3606 24.3377 49.5798 21.718 46.6366 21.4824Z",
    fill: "url(#paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9956 30.6927C45.9956 30.6927 47.3554 26.8456 47.6478 23.1078C47.6478 23.1078 46.6529 22.2181 46.0313 21.8345C45.9339 21.7746 45.8617 21.6788 45.8291 21.566C45.7965 21.4532 45.806 21.3318 45.8556 21.226C46.3126 20.2403 49.0771 16.3703 49.2844 16.3166C50.4097 16.0242 55.0259 13.7398 58.277 18.3684C59.6736 20.3546 58.0003 26.4691 51.6702 32.8019C49.6332 33.1481 47.729 32.5373 45.9956 30.6927Z",
    fill: "url(#paint4_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2356 23.9512C51.2356 23.9512 47.4577 28.6068 42.6288 29.2872C42.6288 29.2872 41.3803 28.1041 40.4527 28.5256C39.5251 28.9471 38.252 30.8151 38.252 30.8151H44.4554C44.4554 30.8151 50.319 30.6001 53.2493 26.8991C53.0102 25.6031 52.3041 24.8307 51.2356 23.9512Z",
    fill: "url(#paint5_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3973 13.3965L54.7799 16.3657C54.7887 16.4319 54.7771 16.4993 54.7467 16.5582C54.7163 16.6171 54.6686 16.6644 54.6107 16.6932C54.1745 16.9082 53.0621 17.2946 51.736 16.5191C51.6619 16.475 51.6014 16.4098 51.5615 16.3311C51.5217 16.2524 51.5043 16.1636 51.5113 16.075L51.6964 13.5736L54.3973 13.3965Z",
    fill: "url(#paint6_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9692 10.3083C49.9692 10.3083 49.9201 13.3123 50.8656 14.3957C51.811 15.4791 54.0277 15.1495 55.0806 13.0537L54.2398 9.03125L49.9692 10.3083Z",
    fill: "url(#paint7_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0241 11.5089C54.0039 11.5121 53.9833 11.5106 53.9636 11.5047C53.944 11.4988 53.9258 11.4885 53.9104 11.4745C53.8949 11.4606 53.8826 11.4433 53.8742 11.4239C53.8658 11.4045 53.8615 11.3835 53.8617 11.3622C53.864 11.0847 53.8487 10.5317 53.7068 10.1335C53.7068 10.1335 53.8692 9.76535 52.7409 10.1747C51.6126 10.584 49.9208 11.1803 49.0799 10.5185C48.2601 9.87318 47.7356 7.22376 50.0325 8.07997C50.0528 8.08773 50.0746 8.09052 50.0961 8.08813C50.1177 8.08573 50.1384 8.07822 50.1567 8.06616C50.175 8.05411 50.1904 8.03783 50.2017 8.0186C50.213 7.99936 50.2199 7.97769 50.2218 7.95524C50.2543 7.53981 50.4398 6.60314 51.4057 6.45103C52.3092 6.31008 52.7182 6.79278 52.875 7.06894C52.8856 7.08805 52.9002 7.10442 52.9177 7.11683C52.9352 7.12924 52.9552 7.13738 52.9761 7.14063C52.9971 7.14388 53.0185 7.14216 53.0387 7.1356C53.0589 7.12904 53.0775 7.11781 53.093 7.10274C53.4044 6.79514 54.2183 6.16642 55.1761 6.81001C55.965 7.34003 56.0134 7.90589 55.9475 8.24256C55.9424 8.26738 55.9436 8.29314 55.951 8.31734C55.9583 8.34154 55.9716 8.36333 55.9894 8.3806C56.0073 8.39787 56.0292 8.41002 56.0529 8.41586C56.0766 8.4217 56.1014 8.42104 56.1248 8.41393C56.4038 8.33247 56.8319 8.3372 57.1521 8.9257C57.5948 9.73966 56.7078 10.2342 56.4454 10.3589C56.4242 10.3688 56.4056 10.3839 56.3913 10.403C56.377 10.4221 56.3675 10.4446 56.3635 10.4684C56.3038 10.8433 55.9965 12.4716 55.0664 13.2642C55.0476 13.2798 55.0255 13.2901 55.0019 13.2944C54.9783 13.2986 54.9541 13.2967 54.9314 13.2886C54.9088 13.2806 54.8884 13.2667 54.8723 13.2483C54.8561 13.2299 54.8447 13.2076 54.839 13.1834L54.4609 11.5765C54.4526 11.5405 54.4315 11.509 54.4019 11.4884C54.3723 11.4678 54.3363 11.4596 54.3012 11.4653L54.0241 11.5089Z",
    fill: "url(#paint8_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9648 11.8124C53.9648 11.8124 54.5768 10.3025 55.0617 10.9062C55.5466 11.5099 54.6645 12.5152 53.9863 12.622L53.9648 11.8124Z",
    fill: "url(#paint9_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5624 31.1755L35.778 21.5121C35.7226 21.3196 35.612 21.1493 35.4611 21.0239C35.3103 20.8984 35.1262 20.8238 34.9336 20.81L31.1742 20.5423C31.0861 20.536 30.9979 20.5525 30.9174 20.5905C30.837 20.6284 30.7669 20.6866 30.7134 20.7597C30.6599 20.8329 30.6247 20.9187 30.611 21.0095C30.5972 21.1003 30.6054 21.1932 30.6347 21.2799L33.7475 30.5079C33.7965 30.6537 33.8844 30.7818 34.001 30.8773C34.1176 30.9728 34.2579 31.0317 34.4055 31.0471L38.108 31.475L38.5624 31.1755Z",
    fill: "url(#paint10_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4271 24.786C33.6353 25.2227 33.9942 25.4786 34.229 25.3576C34.4638 25.2366 34.4859 24.783 34.278 24.3476C34.0702 23.9122 33.7113 23.655 33.4764 23.776C33.2416 23.897 33.2192 24.3493 33.4271 24.786Z",
    fill: "#91B3FA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1072 31.4763C38.1132 31.4766 38.1191 31.4766 38.1251 31.4763L46.0135 31.0615C46.0598 31.0591 46.1053 31.0471 46.1472 31.0264C46.1892 31.0057 46.2268 30.9766 46.2579 30.9407C46.289 30.9049 46.3131 30.863 46.3286 30.8175C46.3442 30.772 46.351 30.7237 46.3487 30.6755C46.3463 30.6272 46.3349 30.5799 46.315 30.5363C46.295 30.4926 46.2671 30.4535 46.2326 30.4211C46.1982 30.3887 46.158 30.3637 46.1142 30.3475C46.0705 30.3313 46.0241 30.3242 45.9778 30.3266L38.0894 30.7414C37.9978 30.7471 37.912 30.7896 37.85 30.8599C37.788 30.9302 37.7546 31.0228 37.7569 31.1181C37.7593 31.2135 37.7971 31.3043 37.8624 31.3712C37.9278 31.4381 38.0155 31.476 38.1072 31.4769V31.4763Z",
    fill: "url(#paint11_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6477 23.167C47.6332 23.167 47.6193 23.1611 47.609 23.1504C47.5987 23.1398 47.5929 23.1253 47.5928 23.1102C47.5873 21.3772 48.2281 19.0834 48.2346 19.0604C48.2387 19.0459 48.2481 19.0337 48.2608 19.0265C48.2736 19.0193 48.2886 19.0176 48.3025 19.0218C48.3164 19.0261 48.3281 19.0359 48.335 19.0492C48.342 19.0624 48.3436 19.078 48.3395 19.0925C48.3333 19.1151 47.6967 21.3934 47.7023 23.1099C47.7023 23.125 47.6965 23.1395 47.6863 23.1502C47.6761 23.1609 47.6622 23.1669 47.6477 23.167Z",
    fill: "url(#paint12_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2349 24.0077C51.2231 24.0075 51.2117 24.0032 51.2025 23.9955C51.1968 23.9909 51.1921 23.9852 51.1886 23.9787C51.1851 23.9721 51.1829 23.965 51.182 23.9576C51.1812 23.9502 51.1817 23.9427 51.1837 23.9355C51.1856 23.9283 51.1889 23.9216 51.1934 23.9157C51.2106 23.8931 52.9254 21.6243 53.5123 20.0768C53.5147 20.0697 53.5185 20.0631 53.5234 20.0575C53.5283 20.0518 53.5342 20.0473 53.5408 20.0442C53.5474 20.041 53.5546 20.0393 53.5619 20.0391C53.5691 20.0389 53.5764 20.0402 53.5831 20.043C53.59 20.0456 53.5962 20.0495 53.6016 20.0546C53.6069 20.0597 53.6112 20.0659 53.6142 20.0728C53.6173 20.0796 53.619 20.087 53.6192 20.0946C53.6194 20.1021 53.6182 20.1096 53.6156 20.1167C53.0229 21.68 51.2983 23.9617 51.2811 23.9843C51.2757 23.9918 51.2688 23.9979 51.2608 24.0019C51.2527 24.006 51.2439 24.008 51.2349 24.0077Z",
    fill: "url(#paint13_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6658 27.4965L53.354 27.0371C53.3463 27.0248 53.3435 27.0099 53.3462 26.9955C53.3488 26.9811 53.3567 26.9683 53.3682 26.9599C53.3797 26.9514 53.3939 26.9479 53.4079 26.9501C53.4218 26.9522 53.4344 26.9599 53.443 26.9716L53.7028 27.3552C56.1358 26.2451 57.6418 23.2161 57.6568 23.1854C57.6634 23.1719 57.6748 23.1617 57.6886 23.1571C57.7024 23.1524 57.7174 23.1537 57.7303 23.1605C57.7432 23.1674 57.753 23.1793 57.7575 23.1936C57.762 23.208 57.7608 23.2236 57.7542 23.2371C57.7389 23.2682 56.1988 26.3672 53.7051 27.4782L53.6658 27.4965Z",
    fill: "url(#paint14_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.7757,
    y1: 51.4057,
    x2: 72.4555,
    y2: 15.4691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 33.1915,
    y1: 34.1273,
    x2: 28.9467,
    y2: 38.3872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 5737.94,
    y1: 8142.55,
    x2: 6564.69,
    y2: 9155.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 40.2386,
    y1: 23.4849,
    x2: 45.7177,
    y2: 29.7454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 66.1833,
    y1: 7.54486,
    x2: 49.7826,
    y2: 23.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 6596.88,
    y1: 13186.6,
    x2: 7992.8,
    y2: 9013.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -1522.16,
    y1: 5381.92,
    x2: -1504.57,
    y2: 4996.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: -2691.66,
    y1: 8361.34,
    x2: -2180.24,
    y2: 7435.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -3139.3,
    y1: 7405.22,
    x2: -3715.85,
    y2: 9263.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: -692.765,
    y1: 2660.69,
    x2: -515.739,
    y2: 2397.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 5416.45,
    y1: 19898.4,
    x2: 7366.46,
    y2: 19898.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 6108.46,
    y1: 2245.66,
    x2: 5759.59,
    y2: 2959.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 49.3768,
    y1: -1.6287,
    x2: 46.7128,
    y2: 37.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 5590.67,
    y1: 4025.51,
    x2: 5104.66,
    y2: 8622.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 10539.5,
    y1: 4434.62,
    x2: 10216,
    y2: 9500.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningFreePackage);
export default __webpack_public_path__ + "static/media/icon-warning-free-package.bb7e82254f8bbf57fecdae366b503895.svg";
export { ForwardRef as ReactComponent };